import * as z from 'zod/mini';

export const SURVEY_ADDRESS_SESSION_KEY = 'opendoor:survey:address-provided';
export const SURVEY_ADDRESS_PROVIDED_EVENT = 'opendoor:survey:address-provided';
const addressMarkerSchema = z.nullable(z.enum(['0', '1']));

export type SurveyAddressStatus = 'not_provided' | 'provided' | 'unavailable';

/** Same-origin, per-tab exclusion shared by address entry and exit surveys. */
export function readSurveyAddressStatus(): SurveyAddressStatus {
  if (typeof window === 'undefined') return 'unavailable';
  try {
    const marker = addressMarkerSchema.safeParse(
      window.sessionStorage.getItem(SURVEY_ADDRESS_SESSION_KEY),
    );
    if (!marker.success) return 'unavailable';
    if (marker.data === '1') return 'provided';

    // Require writable storage before treating a visit as having no address.
    // Otherwise a later selection could fail to persist its exclusion.
    window.sessionStorage.setItem(SURVEY_ADDRESS_SESSION_KEY, '0');
    return 'not_provided';
  } catch {
    return 'unavailable';
  }
}

/** Call only when the visitor selects or submits an address, before navigation. */
export function recordSurveyAddressProvided(): void {
  if (typeof window === 'undefined') return;
  try {
    window.sessionStorage.setItem(SURVEY_ADDRESS_SESSION_KEY, '1');
  } catch {
    // Survey eligibility must never interrupt address intake.
    console.warn('Could not persist the survey address exclusion');
  }
  document.dispatchEvent(new Event(SURVEY_ADDRESS_PROVIDED_EVENT));
}
